module.exports = __webpack_public_path__ + "static/media/icon-tap.52177636.png";